import { useSelector } from "react-redux";
import { parseQuery } from "utility";

import type { EventCategory } from "@spwn/types/spwn/event";
import type { Store } from "store";

export const useQueryString = <T extends Record<string, string>>(): T => {
  const location = useSelector((state: Store) => state.router.location);

  const queryObject = parseQuery(location.search) as T;

  return queryObject || ({} as T);
};

type EventCategoryQuery = {
  category: EventCategory;
};
export const useEventCategoryQuery = () => {
  return useQueryString<EventCategoryQuery>();
};

type VoucherCodeQuery = {
  code: string;
};
export const useVoucherCodeQuery = () => {
  return useQueryString<VoucherCodeQuery>();
};

type GoodsSearchQuery = {
  search: string;
};
export const useGoodsSerachQuery = () => {
  return useQueryString<GoodsSearchQuery>();
};
